import { render, staticRenderFns } from "./Firmbio.vue?vue&type=template&id=c02f40ea&"
import script from "./Firmbio.vue?vue&type=script&lang=js&"
export * from "./Firmbio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports